import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from "../../components/layout/index";
import { DatePicker, Select } from 'antd';
import { FaStar } from 'react-icons/fa';
import { ChevronLeft, Search, Calendar, X } from 'lucide-react';
import dayjs from 'dayjs';
import axios from 'axios';
import { toast } from 'react-toastify';

const { Option } = Select;

const CurebayPatientFeedback = () => {
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;
    
    // Filter states
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const [doctorName, setDoctorName] = useState('');
    const [department, setDepartment] = useState('');
    const [consultationType, setConsultationType] = useState('All');
    const [ratingFilter, setRatingFilter] = useState('All');
    const [feedbackStatus, setFeedbackStatus] = useState('All');
    
    // Data states
    const [feedbackData, setFeedbackData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalEntries, setTotalEntries] = useState(0);
    const pageSize = 10;
    const [selectedFeedback, setSelectedFeedback] = useState(null);
    const [internalNotes, setInternalNotes] = useState('');
    
    // Departments list (you can fetch this from API)
    const departments = ['Cardiology', 'Neurology', 'Orthopedics', 'Pediatrics', 'General Medicine'];
    
    // Consultation types
    const consultationTypes = ['All', 'Video', 'In-Person', 'Phone'];
    
    // Rating options
    const ratingOptions = ['All', '1 Star', '2 Stars', '3 Stars', '4 Stars', '5 Stars'];
    
    // Feedback status options
    const feedbackStatusOptions = ['All', 'Positive', 'Neutral', 'Negative'];
    
    // Mock data - replace with actual API call
    const mockFeedbackData = [
        {
            id: 1,
            patientName: 'Triupti Shukla',
            patientId: 'TEST000999888',
            doctorName: 'Dr. Reksona Pan...',
            doctorDepartment: 'Cardiology',
            department: 'Cardiology',
            consultationType: 'Video',
            consultationDate: '22/01/2026',
            consultationTime: '11:20 - 11:30',
            sentiment: 'Positive',
            rating: 3,
            feedbackSummary: 'Doctor showed up on time an...',
            consultationId: 'ASBH1234',
            prescriptionIssued: 'Yes',
            fullFeedbackText: 'Doctor showed up on time and was very attentive to me. They listened carefully to my concerns, explained the diagnosis clearly, and answered all my questions patiently. The consultation felt thorough and reassuring. I left with a clear understanding of the next steps and treatment plan.',
            ratingDoctorBehavior: 3,
            ratingWaitTime: 3,
            ratingResolution: 3
        },
        {
            id: 2,
            patientName: 'Triupti Shukla',
            patientId: 'TEST000999888',
            doctorName: 'Dr. Reksona Pan...',
            doctorDepartment: 'Cardiology',
            department: 'Cardiology',
            consultationType: 'Video',
            consultationDate: '22/01/2026',
            consultationTime: '11:20 - 11:30',
            sentiment: 'Neutral',
            rating: 3,
            feedbackSummary: 'Doctor showed up on time an...',
            consultationId: 'ASBH1235',
            prescriptionIssued: 'Yes',
            fullFeedbackText: 'Doctor showed up on time and was very attentive to me. They listened carefully to my concerns, explained the diagnosis clearly, and answered all my questions patiently. The consultation felt thorough and reassuring. I left with a clear understanding of the next steps and treatment plan.',
            ratingDoctorBehavior: 3,
            ratingWaitTime: 3,
            ratingResolution: 3
        },
        {
            id: 3,
            patientName: 'Triupti Shukla',
            patientId: 'TEST000999888',
            doctorName: 'Dr. Reksona Pan...',
            doctorDepartment: 'Cardiology',
            department: 'Cardiology',
            consultationType: 'Video',
            consultationDate: '22/01/2026',
            consultationTime: '11:20 - 11:30',
            sentiment: 'Negative',
            rating: 1,
            feedbackSummary: 'Doctor showed up on time an...',
            consultationId: 'ASBH1236',
            prescriptionIssued: 'No',
            fullFeedbackText: 'Doctor showed up on time and was very attentive to me. They listened carefully to my concerns, explained the diagnosis clearly, and answered all my questions patiently. The consultation felt thorough and reassuring. I left with a clear understanding of the next steps and treatment plan.',
            ratingDoctorBehavior: 1,
            ratingWaitTime: 2,
            ratingResolution: 1
        },
        {
            id: 4,
            patientName: 'Triupti Shukla',
            patientId: 'TEST000999888',
            doctorName: 'Dr. Reksona Pan...',
            doctorDepartment: 'Cardiology',
            department: 'Cardiology',
            consultationType: 'Video',
            consultationDate: '22/01/2026',
            consultationTime: '11:20 - 11:30',
            sentiment: 'Positive',
            rating: 4,
            feedbackSummary: 'Doctor showed up on time an...',
            consultationId: 'ASBH1237',
            prescriptionIssued: 'Yes',
            fullFeedbackText: 'Doctor showed up on time and was very attentive to me. They listened carefully to my concerns, explained the diagnosis clearly, and answered all my questions patiently. The consultation felt thorough and reassuring. I left with a clear understanding of the next steps and treatment plan.',
            ratingDoctorBehavior: 4,
            ratingWaitTime: 4,
            ratingResolution: 4
        },
        {
            id: 5,
            patientName: 'Triupti Shukla',
            patientId: 'TEST000999888',
            doctorName: 'Dr. Reksona Pan...',
            doctorDepartment: 'Cardiology',
            department: 'Cardiology',
            consultationType: 'Video',
            consultationDate: '22/01/2026',
            consultationTime: '11:20 - 11:30',
            sentiment: 'Positive',
            rating: 3,
            feedbackSummary: 'Doctor showed up on time an...',
            consultationId: 'ASBH1238',
            prescriptionIssued: 'Yes',
            fullFeedbackText: 'Doctor showed up on time and was very attentive to me. They listened carefully to my concerns, explained the diagnosis clearly, and answered all my questions patiently. The consultation felt thorough and reassuring. I left with a clear understanding of the next steps and treatment plan.',
            ratingDoctorBehavior: 3,
            ratingWaitTime: 3,
            ratingResolution: 3
        }
    ];
    
    useEffect(() => {
        fetchFeedbackData();
    }, [currentPage]);
    
    const fetchFeedbackData = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("auth_token");
            const tenantId = localStorage.getItem("tenantId");
            
            // TODO: Replace with actual API call
            // const response = await axios.get(`${API_URL}feedback/list`, {
            //     headers: {
            //         Authorization: `Bearer ${token}`,
            //         tenantId: tenantId,
            //     },
            //     params: {
            //         page: currentPage,
            //         pageSize: pageSize,
            //         date: selectedDate.format('YYYY-MM-DD'),
            //         doctorName: doctorName,
            //         department: department,
            //         consultationType: consultationType !== 'All' ? consultationType : undefined,
            //         rating: ratingFilter !== 'All' ? ratingFilter : undefined,
            //         status: feedbackStatus !== 'All' ? feedbackStatus : undefined,
            //     }
            // });
            
            // Mock data for now
            setTimeout(() => {
                setFeedbackData(mockFeedbackData);
                setTotalEntries(80);
                setLoading(false);
            }, 500);
        } catch (error) {
            console.error('Failed to fetch feedback data:', error);
            toast.error('Failed to fetch feedback data');
            setLoading(false);
        }
    };
    
    const handleReset = () => {
        setSelectedDate(dayjs());
        setDoctorName('');
        setDepartment('');
        setConsultationType('All');
        setRatingFilter('All');
        setFeedbackStatus('All');
        setCurrentPage(1);
    };
    
    const handleSearch = () => {
        setCurrentPage(1);
        fetchFeedbackData();
    };
    
    const getSentimentColor = (sentiment) => {
        switch (sentiment) {
            case 'Positive':
                return 'bg-green-100 text-green-700 border-green-200';
            case 'Neutral':
                return 'bg-blue-100 text-blue-700 border-blue-200';
            case 'Negative':
                return 'bg-orange-100 text-orange-700 border-orange-200';
            default:
                return 'bg-gray-100 text-gray-700 border-gray-200';
        }
    };
    
    const renderStars = (rating) => {
        return (
            <div className="flex items-center gap-1">
                {[1, 2, 3, 4, 5].map((star) => (
                    <FaStar
                        key={star}
                        className={`text-sm ${
                            star <= rating
                                ? rating === 1 && star === 1
                                    ? 'text-red-500'
                                    : 'text-[#004276]'
                                : 'text-gray-300'
                        }`}
                    />
                ))}
            </div>
        );
    };
    
    const totalPages = Math.ceil(totalEntries / pageSize);
    const startEntry = (currentPage - 1) * pageSize + 1;
    const endEntry = Math.min(currentPage * pageSize, totalEntries);

    const handleCloseSidebar = () => {
        setSelectedFeedback(null);
        setInternalNotes('');
    };

    const handleMarkResolved = () => {
        // TODO: API call to mark as resolved
        toast.success('Feedback marked as resolved');
        handleCloseSidebar();
    };

    const handleEscalate = () => {
        // TODO: API call to escalate
        toast.info('Feedback escalated');
        handleCloseSidebar();
    };
    
    return (
        <DashboardLayout>
            {/* Doctor Details Sidebar */}
            {selectedFeedback && (
                <>
                    <div
                        className="fixed inset-0 bg-black/30 z-40"
                        onClick={handleCloseSidebar}
                        aria-hidden="true"
                    />
                    <div className="fixed top-0 right-0 bottom-0 w-full max-w-md bg-white shadow-xl z-50 flex flex-col overflow-hidden">
                        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
                            <h2 className="text-lg font-semibold text-gray-900">Doctor Details</h2>
                            <button
                                type="button"
                                onClick={handleCloseSidebar}
                                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                                aria-label="Close"
                            >
                                <X className="w-5 h-5 text-gray-600" />
                            </button>
                        </div>
                        <div className="flex-1 overflow-y-auto p-6 space-y-6">
                            {/* Consultation Details */}
                            <div>
                                <h3 className="text-sm font-medium text-[#004276] underline mb-3">Consultation Details</h3>
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <p className="text-xs text-gray-500 uppercase tracking-wide">Consultation ID</p>
                                        <p className="text-sm font-medium text-gray-900 mt-0.5">
                                            {selectedFeedback.consultationId ?? `CONS${selectedFeedback.id}`}
                                        </p>
                                    </div>
                                    <div>
                                        <p className="text-xs text-gray-500 uppercase tracking-wide">Prescription Issued</p>
                                        <p className="text-sm font-medium text-gray-900 mt-0.5">
                                            {selectedFeedback.prescriptionIssued ?? 'Yes'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* Feedback Overview */}
                            <div>
                                <h3 className="text-sm font-medium text-[#004276] underline mb-3">Feedback Overview</h3>
                                <div className="space-y-4">
                                    <div>
                                        <p className="text-xs font-medium text-gray-700 mb-1">Full Feedback Text</p>
                                        <div className="p-3 bg-gray-100 rounded-md text-sm text-gray-900">
                                            {selectedFeedback.fullFeedbackText ?? selectedFeedback.feedbackSummary}
                                        </div>
                                    </div>
                                    <div>
                                        <p className="text-xs font-medium text-gray-700 mb-2">Rating Breakdown</p>
                                        <div className="space-y-2">
                                            <div className="flex items-center justify-between">
                                                <span className="text-sm text-gray-700">Doctor Behavior</span>
                                                {renderStars(selectedFeedback.ratingDoctorBehavior ?? selectedFeedback.rating)}
                                            </div>
                                            <div className="flex items-center justify-between">
                                                <span className="text-sm text-gray-700">Wait Time</span>
                                                {renderStars(selectedFeedback.ratingWaitTime ?? selectedFeedback.rating)}
                                            </div>
                                            <div className="flex items-center justify-between">
                                                <span className="text-sm text-gray-700">Resolution</span>
                                                {renderStars(selectedFeedback.ratingResolution ?? selectedFeedback.rating)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Internal Notes */}
                            <div>
                                <h3 className="text-sm font-medium text-gray-900 mb-2">Internal Notes</h3>
                                <textarea
                                    value={internalNotes}
                                    onChange={(e) => setInternalNotes(e.target.value)}
                                    placeholder="Write here"
                                    rows={4}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#004276] focus:border-transparent"
                                />
                            </div>
                        </div>
                        <div className="p-6 border-t border-gray-200 space-y-3">
                            <button
                                type="button"
                                onClick={handleMarkResolved}
                                className="w-full py-2.5 px-4 rounded-md text-sm font-medium text-white bg-green-600 hover:bg-green-700 transition-colors"
                            >
                                Mark as Resolved
                            </button>
                            <button
                                type="button"
                                onClick={handleEscalate}
                                className="w-full py-2.5 px-4 rounded-md text-sm font-medium text-white bg-red-600 hover:bg-red-700 transition-colors"
                            >
                                Escalate
                            </button>
                        </div>
                    </div>
                </>
            )}

            <div className="mt-6 px-4 min-w-0">
                {/* Header */}
                <div className="flex items-center gap-3 mb-6">
                    <button
                        onClick={() => navigate(-1)}
                        className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                    >
                        <ChevronLeft className="w-5 h-5 text-gray-700" />
                    </button>
                    <h1 className="text-xl font-semibold text-gray-900">Patient Feedback</h1>
                </div>
                
                {/* Filter Section */}
                <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                        {/* Select Date */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Select date
                            </label>
                            <DatePicker
                                value={selectedDate}
                                onChange={(date) => setSelectedDate(date || dayjs())}
                                format="DD/MM/YYYY"
                                className="w-full"
                                placeholder="Today"
                            />
                        </div>
                        
                        {/* Doctor Name */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Doctor Name
                            </label>
                            <div className="relative">
                                <input
                                    type="text"
                                    value={doctorName}
                                    onChange={(e) => setDoctorName(e.target.value)}
                                    placeholder="Enter Doctor Name"
                                    className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#004276] focus:border-transparent"
                                />
                                <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                            </div>
                        </div>
                        
                        {/* Department */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Department
                            </label>
                            <Select
                                value={department}
                                onChange={setDepartment}
                                placeholder="Choose Department"
                                className="w-full"
                            >
                                <Option value="">All Departments</Option>
                                {departments.map((dept) => (
                                    <Option key={dept} value={dept}>
                                        {dept}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                        {/* Consultation Type */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Consultation Type
                            </label>
                            <Select
                                value={consultationType}
                                onChange={setConsultationType}
                                className="w-full"
                            >
                                {consultationTypes.map((type) => (
                                    <Option key={type} value={type}>
                                        {type}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        
                        {/* Rating Filter */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Rating Filter
                            </label>
                            <Select
                                value={ratingFilter}
                                onChange={setRatingFilter}
                                className="w-full"
                            >
                                {ratingOptions.map((rating) => (
                                    <Option key={rating} value={rating}>
                                        {rating}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        
                        {/* Feedback Status */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Feedback Status
                            </label>
                            <Select
                                value={feedbackStatus}
                                onChange={setFeedbackStatus}
                                className="w-full"
                            >
                                {feedbackStatusOptions.map((status) => (
                                    <Option key={status} value={status}>
                                        {status}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </div>
                    
                    {/* Action Buttons */}
                    <div className="flex justify-end gap-3 mt-4">
                        <button
                            onClick={handleReset}
                            className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 font-medium hover:bg-gray-50 transition-colors"
                        >
                            Reset
                        </button>
                        <button
                            onClick={handleSearch}
                            className="px-6 py-2 bg-[#004276] text-white rounded-md font-medium hover:bg-[#003366] transition-colors"
                        >
                            Search
                        </button>
                    </div>
                </div>
                
                {/* Table Section */}
                <div className="bg-white rounded-lg shadow-sm">
                    {loading ? (
                        <div className="p-8 text-center text-gray-500">Loading...</div>
                    ) : (
                        <>
                            <div className="w-full overflow-x-auto rounded-lg border border-gray-200">
    <table className="min-w-[1100px] divide-y divide-gray-200">
        <thead className="bg-gray-50 sticky top-0 z-10">
            <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Patient Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Doctor Name
                </th>
                {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Department
                </th> */}
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Consultation Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Consultation Date
                </th>
                {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Sentiment Tag
                </th> */}
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Rating
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Feedback Summary
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Action
                </th>
            </tr>
        </thead>

        <tbody className="bg-white divide-y divide-gray-200">
            {feedbackData.map((item) => (
                <tr key={item.id} className="hover:bg-gray-50 transition">
                    
                    {/* Patient */}
                    <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900">
                            {item.patientName}
                        </div>
                        <div className="text-xs text-gray-500">
                            {item.patientId}
                        </div>
                    </td>

                    {/* Doctor */}
                    <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900">
                            {item.doctorName}
                        </div>
                        <div className="text-xs text-gray-500">
                            {item.doctorDepartment}
                        </div>
                    </td>

                    {/* Department */}
                    {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.department}
                    </td> */}

                    {/* Consultation Type */}
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.consultationType}
                    </td>

                    {/* Date */}
                    <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">
                            {item.consultationDate}
                        </div>
                        <div className="text-xs text-gray-500">
                            {item.consultationTime}
                        </div>
                    </td>

                    {/* Sentiment */}
                    {/* <td className="px-6 py-4 whitespace-nowrap">
                        <span
                            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${getSentimentColor(
                                item.sentiment
                            )}`}
                        >
                            {item.sentiment}
                        </span>
                    </td> */}

                    {/* Rating */}
                    <td className="px-6 py-4 whitespace-nowrap">
                        {renderStars(item.rating)}
                    </td>

                    {/* Feedback */}
                    <td className="px-6 py-4">
                        <div className="text-sm text-gray-900 min-w-[200px] max-w-[300px]">
                            {item.feedbackSummary}
                        </div>
                    </td>

                    {/* Action */}
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <button
                            className="text-[#004276] hover:text-[#003366] hover:underline"
                            onClick={() => {
                                setSelectedFeedback(item);
                                setInternalNotes('');
                            }}
                        >
                            View Details
                        </button>
                    </td>
                </tr>
            ))}
        </tbody>
    </table>
</div>

                            
                            {/* Pagination */}
                            <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200">
                                <div className="flex-1 flex justify-between sm:hidden">
                                    <button
                                        onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                                        disabled={currentPage === 1}
                                        className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        Previous
                                    </button>
                                    <button
                                        onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                                        disabled={currentPage === totalPages}
                                        className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        Next
                                    </button>
                                </div>
                                <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                                    <div>
                                        <p className="text-sm text-gray-700">
                                            Showing <span className="font-medium">{startEntry}</span> to{' '}
                                            <span className="font-medium">{endEntry}</span> of{' '}
                                            <span className="font-medium">{totalEntries}</span> entries
                                        </p>
                                    </div>
                                    <div>
                                        <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                                            <button
                                                onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                                                disabled={currentPage === 1}
                                                className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                                <span className="sr-only">Previous</span>
                                                &lt; Prev
                                            </button>
                                            {[...Array(totalPages)].map((_, index) => {
                                                const page = index + 1;
                                                if (
                                                    page === 1 ||
                                                    page === totalPages ||
                                                    (page >= currentPage - 1 && page <= currentPage + 1)
                                                ) {
                                                    return (
                                                        <button
                                                            key={page}
                                                            onClick={() => setCurrentPage(page)}
                                                            className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${
                                                                currentPage === page
                                                                    ? 'z-10 bg-[#004276] border-[#004276] text-white'
                                                                    : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50'
                                                            }`}
                                                        >
                                                            {page}
                                                        </button>
                                                    );
                                                } else if (
                                                    page === currentPage - 2 ||
                                                    page === currentPage + 2
                                                ) {
                                                    return (
                                                        <span
                                                            key={page}
                                                            className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700"
                                                        >
                                                            ...
                                                        </span>
                                                    );
                                                }
                                                return null;
                                            })}
                                            <button
                                                onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                                                disabled={currentPage === totalPages}
                                                className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                                <span className="sr-only">Next</span>
                                                Next &gt;
                                            </button>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </DashboardLayout>
    );
};

export default CurebayPatientFeedback;
